export function FoodItem({ name, price, description, image, onSelect }) {
  return (
    <button
      onClick={onSelect}
      className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow group">
      {/* Image placeholder */}
      <div className="w-full h-24 bg-muted rounded-lg mb-3 flex items-center justify-center">
        {image ? (
          // <img src={image} alt={name} className="w-full h-full object-cover rounded-lg" />
          <div className="w-16 h-16 bg-muted-foreground/20 rounded-full">
            <img src={image} alt={name} className="w-full h-full object-cover rounded-lg" />
          </div>
        ) : (
          <div className="w-16 h-16 bg-muted-foreground/20 rounded-full"></div>
        )}
      </div>

      {/* Name */}
      <h3 className="text-sm font-medium text-card-foreground text-center group-hover:text-primary transition-colors">
        {name}
      </h3>
      {/* <p className="text-sm text-gray-500">{description}</p> */}
      <p className="font-semibold mt-2">Rs:{price}</p>
    </button>
  );
}